export default __webpack_public_path__ + "static/media/Cocktail.a9426ec9.mp3";